import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BOItem } from '../../models/BOItem.model';
import { RelativeTypeService } from '../../services/relativeType.service';
import { Utilities } from '../../common/utilities';
import { PatientFarmacologicRecordService } from '../../services/PatientFarmacologicRecords.service';
import { BOPatientFarmacologicRecord } from '../../models/BOPatientFarmacologicRecord.model';

@Component({
  selector: 'app-patient-farmacologic-record',
  templateUrl: './patient-farmacologic-record.component.html',
  styleUrls: ['./patient-farmacologic-record.component.css']
})
export class PatientFarmacologicRecordComponent implements OnInit, OnChanges {
    @Input() id!: number;
    @Input() code!: string;
    @Input() name!: string;
    @Input() enabled!: boolean;
    @Input() posInArray!:number;
    @Input() uniqueId!: string;
    @Input() patientId!: number;
    @Output() posSended = new EventEmitter<{ uniqueId: string }>(); // ← Cambia el tipo
    @Output() posSendedId = new EventEmitter<{ itemId: number }>(); // ← Cambia el tipo



    patientFarmacologicRecordFormGroup = this._formBuilder.group({
        posInArray:{ value: null, disabled: true },
        code: { value: null, disabled: true },
        name:{ value: null, disabled: true },
        enabled:{ value: null, disabled: true },
      });

  constructor( private _formBuilder : FormBuilder,
               private _patientFarmacologicRecordService : PatientFarmacologicRecordService
  ) { }



  patientFarmacologicRecordList: BOPatientFarmacologicRecord[]=[];
  ngOnInit(): void {
    console.log("Entra en ngOnIt, this.patientFarmacologicRecordList es:", this.patientFarmacologicRecordList);
        console.log("this.posInArray es:", this.posInArray, " y su uniqueId es:", this.uniqueId, " y patientId es:", this.patientId);

    this._patientFarmacologicRecordService.getAllByPatientId(this.patientId).subscribe({
      next:(data)=>
      {
       // this.patientFarmacologicRecordList=data;

        this.patientFarmacologicRecordFormGroup.patchValue({
        posInArray: this.posInArray + 1,
        code:this.code,
        name:this.name,
        enabled:this.enabled
      })

      },
      error:(err)=>{
        console.log("Ocurrió un error en la descarga de tipo parientes");
      }
    })
  }


  ngOnChanges(changes: SimpleChanges): void {
    // Evitamos el primer cambio porque ngOnInit ya lo maneja
    if (changes['posInArray'] && !changes['posInArray'].firstChange) {
      this.patientFarmacologicRecordFormGroup.patchValue({
        posInArray: this.posInArray + 1
      });
    }
  }

  deleteItem(): void {
    console.log("Eliminando elemento con ID:", this.uniqueId);
    this.posSended.emit({ uniqueId: this.uniqueId }); // ← Emite ID, no posición
  }
  deleteItemSingle(): void {
    this.posSendedId.emit({ itemId: this.id }); // ← Emite ID, no posición
  }

}

